
import './notFoundPage.css'

const NotFoundPage = () => (
    <div className='not-found-main-container'>
        <div className="not-found-container">
            <img
                src="https://res.cloudinary.com/dhoeemazz/image/upload/v1723056391/20602776_6324911_hyp3qc.svg"
                alt="Not Found"
            />
            <h1>Oops! Page Not Found</h1>
            <p>
                404 - Page Not Found. This page has gone missing. try cheacking the URL or go back to home page.
            </p>
        </div>
    </div>
)


export default NotFoundPage